import * as Yup from "yup";

export const validationSchema = Yup.object({
  auditUpload: Yup.string().required("File is required"),
});
